import { Entry } from '../Entry'

export function Entry20220712() {
  return (
    <Entry title="12/07/2022 - v3.1.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12640/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
